import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from 'react-google-maps';
import markerImage1 from '../../../../../../assets/images/mark_gray_1.gif';
import markerImage2 from '../../../../../../assets/images/mark_gray_2.gif';
import markerImage3 from '../../../../../../assets/images/mark_gray_3.gif';
import markerImage4 from '../../../../../../assets/images/mark_gray_4.gif';
import markerImage5 from '../../../../../../assets/images/mark_gray_5.gif';

class MarkerDetailsWrapper extends Component {
  constructor(props) {
    super(props);

    this.toggleInfo = this.toggleInfo.bind(this);
    this.getInfo = this.getInfo.bind(this);
  }

  getInfo() {
    if (!this.props.isActive) {
      return null;
    }

    const { lat, lng, children } = this.props;

    return (
      <InfoWindow
        position={{ lat, lng }}
      >
        <div>
          {children}
        </div>

      </InfoWindow>
    );
  }

  toggleInfo() {
    this.props.onInfoToggle(this.props.locationId, this.props.lat);
  }

  render() {
    const { lat, lng, index } = this.props;
    const iconArray = [markerImage1, markerImage2, markerImage3, markerImage4, markerImage5];


    return (
      <Marker
        position={{ lat, lng }}
        onClick={this.toggleInfo}
        icon={iconArray[index]}

      >
        {this.getInfo()}
      </Marker>
    );
  }
}

MarkerDetailsWrapper.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  children: PropTypes.node,
  isActive: PropTypes.bool,
  locationId: PropTypes.number,
  onInfoToggle: PropTypes.func,
  index: PropTypes.number,
};

MarkerDetailsWrapper.defaultProps = {
  lat: 0,
  index: 0,
  lng: 0,
  children: null,
  isActive: false,
  locationId: 0,
  onInfoToggle: () => true,
};


export default MarkerDetailsWrapper;
